import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

function Home({ color, className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            fill="none"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <g id="Icon">
                <path
                    id="Vector"
                    d="M9.86896 22V12H15.869V22M3.86896 9L12.869 2L21.869 9V20C21.869 20.5304 21.6582 21.0391 21.2832 21.4142C20.9081 21.7893 20.3994 22 19.869 22H5.86896C5.33852 22 4.82982 21.7893 4.45474 21.4142C4.07967 21.0391 3.86896 20.5304 3.86896 20V9Z"
                    stroke={color || '#0156D7'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}

Home.propTypes = propTypes;
Home.defaultProps = defaultProps;

export default Home;
